
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enews-registration",
      function () {
        return require("private-next-pages/enews-registration/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enews-registration"])
      });
    }
  